import styles from "./index.module.scss";

export default function GentleReminderCard({ ...props }) {
  return (
    <div className={styles.gentleReminderCard}>
      <span className={styles.label}>{props.label}</span>{" "}
      <span className={styles.description}>{props.description}</span>
    </div>
  );
}
